export default __webpack_public_path__ + "static/media/logo.23444f77.9b0795ee.svg";